module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-authors"
    }
  }, [_c('h1', [_vm._v("About the Authors")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("John R. Christensen")]), _vm._v(" has spent his professional life as an Executive Life Strategist with a broad base of international clientele. John has established a reputation as a thought leader through his cutting-edge coaching process. As an author, John’s writing grasps the urgency of vital words and ideas in all forms of communication. The themes of leadership, empowerment and self-development inform both his critical and creative writing. He resides with his wife Hazel, in Burlington, Ontario, Canada.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_vm._v("Roger J. Preis")]), _vm._v(" is President of RPE Career Dynamics specializing in executive coaching, career & life/work planning, organizational development and management consulting. Previously, Roger was President of Robert Half International Inc. in Connecticut, and the Greater New York area. He has also held corporate positions in recruitment, employment/staffing and employee relations at Chesebrough-Pond’s/Unilever. Roger was also on the faculty at the University of Connecticut.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Roger serves in non-profit board leadership roles, including the Boys & Girls Club in Vermont and previously, VNA & Hospice Care in Connecticut. Roger received the prestigious national Dependable Leader award from Boys & Girls Clubs of America. Roger has also been a two-time recipient of the Boys & Girls Clubs of America’s National Service Award.")]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0